import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import MagnetCard from './components/MagnetCard';

export default function LeadMagnetsPage() {
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    document.title = 'Free Ireland Relocation Guides & Resources | Ireland Bound';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Download free comprehensive guides, checklists, and templates for moving to Ireland from USA. Expert resources for visas, housing, jobs, banking, and more.');
    }
  }, []);

  const magnets = [
    {
      title: 'Complete Ireland Relocation Checklist',
      description: 'Step-by-step timeline with everything you need to do before, during, and after your move to Ireland.',
      icon: 'ri-checkbox-multiple-line',
      fileSize: '2.4 MB',
      pages: '28 pages',
      downloadUrl: '/downloads/ireland-relocation-checklist.pdf',
      image: `https://public.readdy.ai/ai/img_res/0bedc1fcf29708ec84552bf3a7a84c05.jpg`
    },
    {
      title: 'Cost of Living Calculator Spreadsheet',
      description: 'Interactive Excel spreadsheet to compare your US expenses with Ireland costs across 50+ categories.',
      icon: 'ri-calculator-line',
      fileSize: '1.8 MB',
      pages: '12 sheets',
      downloadUrl: '/downloads/cost-calculator-spreadsheet.xlsx',
      image: `https://readdy.ai/api/search-image?query=financial%20spreadsheet%20with%20calculator%20and%20euro%20currency%20symbols%2C%20professional%20business%20style%2C%20clean%20modern%20aesthetic&width=800&height=600&seq=magnet2&orientation=landscape`
    },
    {
      title: 'Visa Application Template Pack',
      description: 'Complete templates, checklists, and sample documents for all major Irish visa types for Americans.',
      icon: 'ri-passport-line',
      fileSize: '3.2 MB',
      pages: '45 pages',
      downloadUrl: '/downloads/visa-application-templates.pdf',
      image: `https://readdy.ai/api/search-image?query=passport%20with%20visa%20stamps%20and%20official%20documents%20on%20desk%2C%20professional%20immigration%20office%20style%2C%20organized%20and%20clean&width=800&height=600&seq=magnet3&orientation=landscape`
    },
    {
      title: 'Irish Banking Setup Guide',
      description: 'Complete guide to opening bank accounts, transferring money, and managing finances in Ireland.',
      icon: 'ri-bank-line',
      fileSize: '2.1 MB',
      pages: '22 pages',
      downloadUrl: '/downloads/banking-setup-guide.pdf',
      image: `https://readdy.ai/api/search-image?query=modern%20Irish%20bank%20building%20with%20euro%20currency%20and%20financial%20documents%2C%20professional%20banking%20style%2C%20bright%20and%20trustworthy&width=800&height=600&seq=magnet4&orientation=landscape`
    },
    {
      title: 'Job Search Strategy Workbook',
      description: 'Proven strategies, resume templates, and networking tips for Americans finding jobs in Ireland.',
      icon: 'ri-briefcase-line',
      fileSize: '2.8 MB',
      pages: '35 pages',
      downloadUrl: '/downloads/job-search-workbook.pdf',
      image: `https://readdy.ai/api/search-image?query=professional%20job%20interview%20preparation%20with%20resume%20and%20laptop%2C%20modern%20office%20setting%2C%20confident%20and%20successful%20atmosphere&width=800&height=600&seq=magnet5&orientation=landscape`
    },
    {
      title: 'Housing Finder Toolkit',
      description: 'Complete guide to finding, viewing, and securing rental housing in Ireland with contract templates.',
      icon: 'ri-home-4-line',
      fileSize: '2.6 MB',
      pages: '31 pages',
      downloadUrl: '/downloads/housing-finder-toolkit.pdf',
      image: `https://readdy.ai/api/search-image?query=beautiful%20Irish%20townhouse%20with%20keys%20and%20rental%20contract%20documents%2C%20welcoming%20home%20style%2C%20warm%20and%20inviting&width=800&height=600&seq=magnet6&orientation=landscape`
    },
    {
      title: 'Healthcare System Navigator',
      description: 'Understanding Irish healthcare, registering with GP, getting medical card, and health insurance options.',
      icon: 'ri-heart-pulse-line',
      fileSize: '1.9 MB',
      pages: '24 pages',
      downloadUrl: '/downloads/healthcare-navigator.pdf',
      image: `https://readdy.ai/api/search-image?query=medical%20stethoscope%20with%20health%20insurance%20documents%20and%20Irish%20medical%20card%2C%20professional%20healthcare%20style%2C%20clean%20and%20reassuring&width=800&height=600&seq=magnet7&orientation=landscape`
    },
    {
      title: 'Tax Planning Workbook for Americans',
      description: 'Navigate dual tax obligations, understand Irish tax system, and maximize deductions as US citizen.',
      icon: 'ri-file-chart-line',
      fileSize: '2.3 MB',
      pages: '29 pages',
      downloadUrl: '/downloads/tax-planning-workbook.pdf',
      image: `https://readdy.ai/api/search-image?query=tax%20documents%20with%20calculator%20and%20financial%20charts%2C%20professional%20accounting%20style%2C%20organized%20and%20detailed&width=800&height=600&seq=magnet8&orientation=landscape`
    },
    {
      title: 'Pet Relocation Planner',
      description: 'Complete timeline, requirements, costs, and veterinary checklists for bringing pets to Ireland.',
      icon: 'ri-bear-smile-line',
      fileSize: '1.7 MB',
      pages: '18 pages',
      downloadUrl: '/downloads/pet-relocation-planner.pdf',
      image: `https://readdy.ai/api/search-image?query=happy%20dog%20and%20cat%20with%20pet%20carrier%20and%20travel%20documents%2C%20loving%20pet%20care%20style%2C%20warm%20and%20friendly%20atmosphere&width=800&height=600&seq=magnet9&orientation=landscape`
    },
    {
      title: 'Cultural Integration Guide',
      description: 'Master Irish customs, etiquette, slang, and social norms to fit in and make friends quickly.',
      icon: 'ri-team-line',
      fileSize: '2.0 MB',
      pages: '26 pages',
      downloadUrl: '/downloads/cultural-integration-guide.pdf',
      image: `https://readdy.ai/api/search-image?query=friendly%20people%20socializing%20in%20Irish%20pub%20with%20traditional%20music%2C%20warm%20community%20atmosphere%2C%20welcoming%20and%20authentic&width=800&height=600&seq=magnet10&orientation=landscape`
    },
    {
      title: 'First 90 Days Action Plan',
      description: 'Week-by-week checklist of everything to accomplish in your first three months in Ireland.',
      icon: 'ri-calendar-check-line',
      fileSize: '1.6 MB',
      pages: '20 pages',
      downloadUrl: '/downloads/first-90-days-plan.pdf',
      image: `https://readdy.ai/api/search-image?query=calendar%20with%20checkmarks%20and%20action%20items%2C%20organized%20planning%20style%2C%20motivating%20and%20clear&width=800&height=600&seq=magnet11&orientation=landscape`
    },
    {
      title: 'Irish Driving Guide for Americans',
      description: 'Everything about driving on the left, getting Irish license, insurance, and road rules.',
      icon: 'ri-steering-2-line',
      fileSize: '1.5 MB',
      pages: '16 pages',
      downloadUrl: '/downloads/irish-driving-guide.pdf',
      image: `https://readdy.ai/api/search-image?query=car%20driving%20on%20scenic%20Irish%20country%20road%20with%20road%20signs%2C%20safe%20driving%20style%2C%20beautiful%20countryside&width=800&height=600&seq=magnet12&orientation=landscape`
    }
  ];

  return (
    <>
      <div className="min-h-screen bg-gradient-to-b from-emerald-50 to-white">
        <Navbar />

        {/* Hero Section */}
        <section className="relative pt-32 pb-20 px-4">
          <div className="absolute inset-0 bg-gradient-to-br from-emerald-600/10 to-blue-600/10"></div>
          <div className="max-w-7xl mx-auto relative z-10">
            <div className="text-center max-w-3xl mx-auto">
              <div className="inline-flex items-center gap-2 bg-emerald-100 text-emerald-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
                <i className="ri-gift-line"></i>
                Free Resources Library
              </div>
              <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
                Free Ireland Relocation <span className="text-emerald-600">Guides & Tools</span>
              </h1>
              <p className="text-xl text-gray-600 mb-8">
                Download comprehensive guides, checklists, and templates to make your move to Ireland smooth and successful. All resources created by relocation experts.
              </p>
              <div className="flex items-center justify-center gap-6 text-sm text-gray-600">
                <div className="flex items-center gap-2">
                  <i className="ri-check-line text-emerald-600 text-xl"></i>
                  <span>Expert-Created Content</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-check-line text-emerald-600 text-xl"></i>
                  <span>Instantly Downloadable</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-check-line text-emerald-600 text-xl"></i>
                  <span>100% Free</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Resources Grid */}
        <section className="py-16 px-4">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {magnets.map((magnet, index) => (
                <MagnetCard key={index} {...magnet} />
              ))}
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="py-20 px-4 bg-white">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                Why Download Our Guides?
              </h2>
              <p className="text-xl text-gray-600">
                Created by experts who've helped hundreds of Americans relocate successfully
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center p-6">
                <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-lightbulb-line text-3xl text-emerald-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Expert Knowledge</h3>
                <p className="text-gray-600">
                  Compiled by relocation specialists with years of experience helping Americans move to Ireland
                </p>
              </div>

              <div className="text-center p-6">
                <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-time-line text-3xl text-emerald-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Save Time</h3>
                <p className="text-gray-600">
                  Skip months of research with our comprehensive guides that cover everything you need to know
                </p>
              </div>

              <div className="text-center p-6">
                <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-line text-3xl text-emerald-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Avoid Mistakes</h3>
                <p className="text-gray-600">
                  Learn from others' experiences and avoid common pitfalls that cost time and money
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 px-4 bg-gradient-to-br from-emerald-600 to-emerald-700">
          <div className="max-w-4xl mx-auto text-center text-white">
            <h2 className="text-4xl font-bold mb-6">
              Need Personalized Guidance?
            </h2>
            <p className="text-xl mb-8 text-emerald-50">
              Chat with our Relocation Expert for personalized answers to your specific questions about moving to Ireland
            </p>
            <button
              onClick={() => {
                const widget = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
                if (widget) widget.click();
              }}
              className="bg-white text-emerald-600 px-8 py-4 rounded-lg font-bold text-lg hover:bg-emerald-50 transition-colors whitespace-nowrap inline-flex items-center gap-2"
            >
              <i className="ri-chat-3-line text-xl"></i>
              Talk to Relocation Expert
            </button>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}
